import Vue from 'vue'

  export interface IApiErrorData {
    code: string
    text: string
  }

  export interface IError {
    status: 'ok' | 'error'
    text: string
  }

const errors: IApiErrorData[] = [
  { code: '0191', text: 'sign_in.error.0191' },
  { code: '0192', text: 'sign_in.error.0192' }
]

export default class ApiError {
  public static getError (code: string | number): IError {
    if (code !== '01') {
      const error = errors.find(error => error.code === String(code))

      if (error) {
        return { status: 'error', text: error.text }
      }

      return { status: 'error', text: 'sign_in.unknown_error' }
    }

    return { status: 'error', text: 'ok' }
  }
}
